/**
 * OnboardingGuard Component
 *
 * Redirects users to Settings if they haven't completed onboarding
 * Wraps protected routes that require onboarding completion
 */

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isOnboardingComplete } from '../utils/onboarding';

export default function OnboardingGuard({ children }) {
  const { contractor, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't check during loading
    if (loading) return;

    // Don't redirect if already on settings page
    if (location.pathname === '/settings') return;

    // Check if onboarding is complete
    if (contractor && !isOnboardingComplete(contractor)) {
      navigate('/settings?onboarding=true');
    }
  }, [contractor, loading, navigate, location.pathname]);

  // Show loading or children
  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return children;
}
